import {Router, Routes, Route, Outlet, Link } from 'react-router-dom'

import Uganda from './uganda';
import Uganda_p2_subjects from './uganda_p2_subjects';
import TopNavbar from '../../components/TopNavbar';
import International_countries from '../international_countries';

const Uganda_p2 = ( ) => {
 
  return (
    <>
 <TopNavbar />
    <Uganda />
    <International_countries />
  <Uganda_p2_subjects />  
  
     <Outlet />
   

</>
  );
}

export default Uganda_p2;

